module.exports = __webpack_public_path__ + "img/010.7ed960d3.jpg";